import React from 'react';

function SectionHeading({ eyebrow, title, subtitle, id, align = 'center' }) {
  const alignClass =
    align === 'left' ? 'text-left items-start' : 'text-center items-center mx-auto';

  return (
    <header className={`mb-10 md:mb-14 flex max-w-3xl flex-col ${alignClass}`}>
      {eyebrow ? (
        <p className="mb-2 text-sm font-semibold uppercase tracking-wider text-optical-600">{eyebrow}</p>
      ) : null}
      <h2 id={id} className="font-display text-3xl font-semibold tracking-tight text-slate-900 md:text-4xl">
        {title}
      </h2>
      {subtitle ? <p className="mt-4 text-lg leading-relaxed text-slate-600">{subtitle}</p> : null}
    </header>
  );
}

export default SectionHeading;
